import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

import { NeuButton } from '@neutron/react';

import {
  BackgroundImage,
  ErrorContainer,
  H1,
  H4,
  StyledDiv,
  Text
} from './ErrorPages.styles';
import ErrorPageImg from '../../assets/images/ErrorPageImg.png';
import { clearUser, setSessionId } from '../../redux/actions';

const NoAccessLocation = () => {
  const { removeUser, signinRedirect, signoutSilent } = useAuth();

  const dispatch = useDispatch();
  // appInsights.trackEvent({
  //   name: 'Login_Failure'
  // });
  const navigate = useNavigate();

  const gotoLogin = () => {
    window.localStorage.removeItem('authToken');
    window.localStorage.removeItem('orbitLastPath');
    window.localStorage.removeItem('34');
    sessionStorage.removeItem('sessionId');
    dispatch(setSessionId(''));
    dispatch(clearUser());
    removeUser();
    signoutSilent();
    if (process.env.REACT_APP_ENV === 'production') {
      console.log('Authorizing user...');
      signinRedirect();
    } else {
      navigate('/login');
    }
  };

  return (
    <StyledDiv>
      <BackgroundImage src={ErrorPageImg} alt="error page" />
      <ErrorContainer>
        <H1>400</H1>
        <H4>No Access Location</H4>
        <Text>
          Your Orbit access is incorrectly configured. <br /> <br />
          Your manager must update your access via <br />
          Access Central with a facility or division selection.
        </Text>
        <NeuButton color="blue" kind="primary" size="small" onClick={gotoLogin}>
          Go Home
        </NeuButton>
      </ErrorContainer>
    </StyledDiv>
  );
};

export default NoAccessLocation;
